// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"292":"cdf3dda4139e0e20","431":"6349d80d989faaa9"}[chunkId] + ".css";
};